/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Edit link request
 */
export interface GoldenTransferLinkEditRequest {
  id: number;
  allowWithdraw: boolean;
  autoBook: boolean;
  active: boolean;
}
